import MainImage from '../voluntary-template/icons/VoluntaryProperty.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/clinical_notes.svg';
import VectorThird from '../voluntary-template/icons/box/portfolio.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/VoluntaryPropertyGPO.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const voluntaryPropertyResources = {
  en: {
    voluntaryProperty: {
      title: 'Property Insurance',
      description:
        'Comprehensive insurance coverage for buildings, equipment, goods, machinery, and other movable and immovable property. The insurance considers business specifics or personal needs, covering both common and force majeure risks.',
      buttonText: 'Submit Application',
      infoCards: [
        {
          title: 'Everything Protected',
          content:
            'Covers real estate, equipment, machinery, goods, and materials.',
        },
        {
          title: 'Flexible Terms',
          content:
            'We tailor insurance programs to fit your property specifics and the requirements of lessors, landlords, or banks.',
        },
        {
          title: 'Protection from Key Risks',
          content:
            'Coverage includes fire, flooding, theft, natural disasters, vandalism, and business interruption.',
        },
      ],
      coverage: [
        {
          title: 'What We Insure',
          content: [
            'Buildings, premises, and utility systems',
            'Commercial, industrial, and office equipment',
            'Goods, raw materials, finished products',
            'Personal property (for individuals)',
          ],
        },
        {
          title: 'Covered Risks',
          content: [
            'Fire, flooding, explosion',
            'Burglary, robbery',
            'Damage due to natural disasters',
            'Intentional unlawful acts by third parties',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance Amount',
          content:
            'Determined based on the market value of the property or its book value as per documentation.',
        },
        {
          title: 'Coverage Period',
          content: 'From 3 months to 1 year or more — as agreed.',
        },
        {
          title: 'Coverage Territory',
          content:
            'Republic of Kazakhstan, the address of the insured object is specified in the policy.',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    voluntaryProperty: {
      title: 'Мүлікті сақтандыру',
      description:
        'Жылжымайтын мүлік немесе жылжымалы мүлік объектілері бұзылған немесе зақымдалған кезде болуы мүмкін залалдарды өтеудің сенімді әдісі.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Мүлік иесіне өрт, су басу және т.б. сол сияқты күтпеген жағдайлар туындаған жағдайда, сақтандыру компаниясынан өтемақы алуға мүмкіндік береді.',
        },
        {
          title: 'Дербес талаптар',
          content:
            'Сақтандыру талаптары объектіге және құнға байланысты әрбір клиент бойынша дербес белгіленеді.',
        },
        {
          title: 'Сенімділікті арттыру',
          content:
            'Сіздің сақтандырылған мүлкіңіз қажет болған жағдайда, белгілі халықаралық қайта сақтандыру компанияларында қосымша қорғаныс алуы мүмкін.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          description:
            'Сақтанушыға / сақтандырылушыға тиесілі коммерциялық мүлікті:',
          content: [
            'Жылжымалы / жылжымайтын мүлікті',
            'Жабдықтыы',
            'Қоймадағы тауарды / айналымдағы тауарды',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          description:
            'Өтелетін тәуекелдердің нақты тізбесі сақтандыру шартында (талаптарында) көрсетіледі.',
          content: [
            'Өрт, су басу, жарылыс',
            'Ұрлық, тонау',
            'Табиғи апаттардан зақымдауы',
            'Үшінші тұлғалардың құқыққа қарсы әрекеттері',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content:
            'Мүлікті сақтандыру кезінде сақтандыру сомасы төмендегілер мөлшерінде белгіленуі мүмкін: нақты құны, баланстық құн, кепіл құны.',
        },
        {
          title: 'Қолданыс мерзімі',
          content: '12 ай.',
        },
        {
          title: 'Сақтандыру аумағы',
          content: 'Мүліктің орналасқан мекенжайы.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '22 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'Ғимараттар, жабдықтар, тауарлар, техника және басқа да жылжымалы әрі жылжымайтын мүліктерге кешенді сақтандыру қорғанысын ұсыныңыз.',
    },
  },
  ru: {
    voluntaryProperty: {
      title: 'Страхование имущества',
      description:
        'Надежный способ компенсировать возможные потери при разрушении или повреждении  объектов недвижимой или движимой собственности.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Позволяет владельцу имущества получить компенсацию от страховой компании в случае возникновения непредвиденных ситуаций, таких как пожар, затопление и т.д.',
        },
        {
          title: 'Персональные условия',
          content:
            'Условия страхования устанавливаются по каждому клиенту индивидуально, в зависимоти от объекта и стоимости.',
        },
        {
          title: 'Повышение доверия',
          content:
            'Ваше застрахованное имущество может иметь дополнительную защиту в известных международных перестраховочных компаниях, при необходимости.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          description:
            'Коммерческое имущество, принадлежащая Страхователю/Застрахованному:',
          content: [
            'Движимое/недвижимое имущество',
            'Оборудование',
            'Товар на складе / товар в обороте',
          ],
        },
        {
          title: 'От каких рисков',
          description:
            'Конкретный перечень покрываемых рисков указывается  в договоре (-ах) страхования.',
          content: [
            'Пожар, затопление, взрыв',
            'Кража со взломом, грабёж',
            'Повреждение в результате стихийных бедствий',
            'Противоправные действия третьих лиц',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'При страховании имущества страховая сумма может быть установлена в размере: действительной стоимости, балансовой стоимости, залоговой стоимости.',
        },
        {
          title: 'Срок действия',
          content: '12 месяцев.',
        },
        {
          title: 'Территория страхования',
          content: 'Адрес нахождения имущества.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '22 филиала',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'Комплексная страховая защита зданий, оборудования, товаров, техники и другого движимого и недвижимого имущества.',
    },
  },
  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем?',
      description:
        'Коммерческое имущество, принадлежащая Страхователю/Застрахованному:',
      content: [
        'движимое/недвижимое имущество',
        'оборудование',
        'товар на складе / товар в обороте',
      ],
      image: Checkbox,
    },
    {
      title: 'От каких рисков?',
      description:
        'Конкретный перечень покрываемых рисков указывается  в договоре (-ах) страхования',
      content: [
        'Пожар, затопление, взрыв',
        'Кража со взломом, грабёж',
        'Повреждение в результате стихийных бедствий',
        'Противоправные действия третьих лиц',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content:
        'Устанавливается исходя из рыночной стоимости имущества или балансовой стоимости по документам.',
    },
    {
      title: 'Срок действия',
      content: 'От 3 месяцев до 1 года и более — по согласованию.',
    },
    {
      title: 'Территория действия',
      content:
        'Республика Казахстан, адрес застрахованного объекта указывается в полисе.',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default voluntaryPropertyResources;
